import React, { createContext, useContext, useRef, useState } from 'react';
import { MenuType } from './menu'
import Fashion, { Action as FashionAction } from './fashion'
import Context from './context'
import TContext from '../context';
import { Dialog } from '@nutui/nutui-react';


export const ChildContext = createContext<any>(null);
interface Props {
    Actions?: any
    children?: any
}

export const Index: React.FC<Props> = (props: Props) => {
    const [notEmptyCodes, setInnerNotEmptyCodes] = useState<any[]>([])
    const tc = useContext(TContext)
    const fashionAc = useRef<FashionAction>()

    //显示一级组件
    const showPlugin = (key: MenuType) => {
        tc?.onEditMode(key)
        switch (key) {


            case MenuType.SHANGWU:
                Dialog.alert({
                    title: t('温馨提示'),
                    content: <div>
                        <p>{ t('如果您在使用使用过程中遇到任何问题，请联系我们第一时间帮您解决；') }</p>
                        <p>{ t('如果您也想拥有这样一套小程序，请联系我们；') }</p>
                        <p>{ t('微信号：boff1024') }</p>
                    </div>,
                    noCancelBtn: true
                });
                return
        }
    }

    //子操作完成


    const onDelCutpartObject = () => {
        const obj = tc?.curCanvasClient?.getFabricCanvas().getActiveObject()
        if (obj) {
            tc?.curCanvasClient?.getFabricCanvas().remove(obj)
            tc?.curCanvasClient?.getFabricCanvas().renderAll()
        }
    }



    //检查所有裁片是否为空
    const checkNotEmptyCodes = () => {
        setInnerNotEmptyCodes(tc?.fabricClient?.isEmptyAll())
    }

    return (
        <Context.Provider value={{
            showPlugin,
            onDelCutpartObject,
            checkNotEmptyCodes,
            notEmptyCodes,
            // doOrder
        }}>
            {/* 头部 */}
            {/* <Head
                action={headAc}
            /> */}
            {props.children}
            {/* 操作标题X √ */}
            {/* <ActionTitle
                action={actionTitleAc}
            /> */}
            {/* 素材组件 */}
            {/* <Pattern
                action={partternAc}
            /> */}
            {/* 裁片展示组件 */}
            {/* <Cutpart
                action={cutpartAc}
            /> */}
            {/* 涂鸦组件 */}
            {/* <Graffiti
                action={graffitiAc}
            /> */}
            {/* 文字组件 */}
            {/* <Text
                action={textAc}
            /> */}
            {/* <Fashion
                action={fashionAc}
            /> */}
            {/* <Info
                action={infoAc}
            /> */}
        </Context.Provider>
    )
}

export default Index
